module.exports = __webpack_public_path__ + "static/media/Thought-leaders-basil.59b919ff.jpg";